
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import TooltipWindow from '@/components/windows/TooltipWindow.vue';
import PreviewJobHeader from '@/components/jobDetailed/previewJob/PreviewJobHeader.vue';
import PreviewJobLoadBody from '@/components/jobDetailed/previewJob/PreviewJobLoadBody.vue';
import { JobDetailedData } from '@/models/jobDetailed';

@Component({
  components: {
    TooltipWindow,
    PreviewJobHeader,
    PreviewJobLoadBody,
  },
})
export default class AffiliatedJobsPreviewJobDialog extends Vue {
  @Prop(Number) public jobId: number;
  @Prop(Boolean) public isShow: boolean;

  public dialog = false;
  public jobDate = '';

  @Watch('isShow', { immediate: true })
  private watchIsShow(isShow: boolean) {
    this.dialog = isShow;
    if (!isShow) {
      this.jobDate = '';
    }
  }

  public handleLoaded(job: JobDetailedData): void {
    this.jobDate = job.rockhopper_date;
  }

  public handleInput() {
    this.$emit('close');
  }
}
